import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";

export interface IExtractJDProps {
  jd: string;
  token?: string;
}

export interface IExtractJDResponse {
  jobTitle: string | null;
  sector: string | null;
  location_country: string | null;
  location_city: string | null;
  level: string | null;
  type: string | null;
  years_of_experience: string | null;
  description: string | null;
  jobsummary: string | null;
  employment_type: string | null;
  language: string | null;
  company_name: string | null;
  skills: string[];
}

export const extractJD = async (props: IExtractJDProps) => {
  const url = `${END_POINT.BASE_URL}/job-creation-extract-jd`;

  const headers: Record<string, string> = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  if (props.token) {
    headers.Authorization = `Bearer ${props.token}`;
  }

  const response = await axios.post<IExtractJDResponse>(
    url,
    { jd: props.jd },
    { headers }
  );

  return response.data;
};

export const useExtractInformationJD = () => {
  return useMutation(extractJD);
};

